export function getValueFromCustomString(url, key) {
  const queryString = url.split("?").slice(1).join("&");
  const params = new URLSearchParams(queryString);
  return params.get(key);
}
